// extracted by mini-css-extract-plugin
export default {"container":"PomodoroContainer_container__5kK40","info":"PomodoroContainer_info__zWqsJ"};